import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import axios from '../../config/axios';

import DetailData from '../DetailTimetable/components/DetailData';

const useStyles = makeStyles(() => ({
    root: {
        padding: '24px',
    },
}));

export default function DetailTimetable(props) {
    const { className, ...rest } = props;

    const classes = useStyles();
    const [bookings, setBooking] = useState();
  
    useEffect(() => {
      let mounted = true;
  
      const fetchAdmin = () => {
        axios.get('/api/bookingdetails/1').then(response => {
            if (mounted) {
                setBooking(response.data.bookingdetails);
            }
        });
    };
  
    fetchAdmin();
  
        return () => {
            mounted = false;
        };
    }, []);
  
    if (!bookings) {
        return null;
    }

    return (
        <Grid
            {...rest}
            className={clsx(classes.root, className)}
            container
            spacing={3}
        >
            <Grid
                item
                lg={6}
                md={6}
                xl={4}
                xs={12}
            >
                <DetailData bookings={bookings} />
            </Grid>
            
        </Grid>
    )
}




